export enum BettingOptionsFormat {
    DECIMAL = 'decimal',
    AMERICAN = 'american',
    FRACTIONAL = 'fractional',
    HONGKONG = 'hongkong',
    CASINO = 'casino',
}
